import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { AppLanguage } from '@shared/models/app-language.model';
import { TranslocoPipe } from '@jsverse/transloco';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-language-picker',
  imports: [
    SharedModule,
    TranslocoPipe,
    Popover
  ],
  templateUrl: './language-picker.component.html',
  styleUrl: './language-picker.component.scss'
})
export class LanguagePickerComponent {

  @ViewChild('op', { static: false }) op!: Popover;

  @Input() languageOptions!: AppLanguage[];

  currentLang!: AppLanguage;

  @Input() set selectedLanguage(lang: AppLanguage) {
    this.currentLang = lang;
  }

  @Output() languageChange = new EventEmitter<AppLanguage>();

  entryClicked(lang: AppLanguage): void {
    this.languageChange.emit(lang);
    this.op.hide();
  }
}
